import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalCashManagement: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                d="M9.933 17.882c.18.105.27.157.397.184a.925.925 0 0 0 .34 0c.127-.027.217-.08.397-.184C12.65 16.958 17 14.058 17 10.07V6.184c0-.65 0-.974-.106-1.254a1.625 1.625 0 0 0-.445-.64c-.224-.198-.528-.312-1.136-.54l-4.357-1.634c-.168-.063-.253-.095-.34-.108a.813.813 0 0 0-.232 0c-.087.013-.171.045-.34.108L5.686 3.75c-.608.228-.912.342-1.136.54-.198.174-.35.394-.445.64C4 5.21 4 5.534 4 6.184v3.886c0 3.988 4.35 6.888 5.933 7.812Z"
                {...pathProps}
            />
        </IconSVG>
    );
};
